import { types, actions } from './requests'
export const DELETEINTERVAL_TYPES = {
    ...types('DELETEINTERVAL'),
}
export const DELETEINTERVAL_ACTIONS = {
    ...actions('DELETEINTERVAL'),
}